import React from "react";
import Routes from "./Routes";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
    <ToastContainer autoClose={3000} />
    <Routes />
    </>
  );
}

export default App;
